import { render, staticRenderFns } from "./newCompanyType.vue?vue&type=template&id=106c603b&scoped=true&"
import script from "./newCompanyType.vue?vue&type=script&lang=js&"
export * from "./newCompanyType.vue?vue&type=script&lang=js&"
import style0 from "./newCompanyType.vue?vue&type=style&index=0&id=106c603b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106c603b",
  null
  
)

export default component.exports